export default __webpack_public_path__ + "static/media/amazon.165ba583.png";